export default __webpack_public_path__ + "static/SRF 1085 - Product Specifications & Technical Data-a0a6a9cc0aae5952d2ef43a8e5f1ebfc.pdf";